// extracted by mini-css-extract-plugin
export default {"paymentSection":"V7-z"};